import React from "react";

interface Props {
  alt: string;
  src: string;
  className: string;
}

export default ({ alt, src, className }: Props) => (
  <>
    <noscript>
      <img className={className} src={src} alt={alt} />
    </noscript>
    <img
      alt={alt}
      src="https://cdnimg.webstaurantstore.com/uploads/design/2014/1/blank.png"
      data-src={src}
      className={`${className} llvendor`}
    />
  </>
);
